import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-header',
  standalone: true,
  imports: [],
  templateUrl: './modal-header.component.html',
  styleUrl: './modal-header.component.scss'
})
export class ModalHeaderComponent {
  @Input() public title : string = '';
	constructor(
    public activeModal: NgbActiveModal
  ) { 
    
  }
  
	close () {
		this.activeModal.close(false);
	}
}
